// extracted by mini-css-extract-plugin
module.exports = {"expertiseList":"style_expertiseList__gD3Hu"};